import axios from 'axios';

export type Initiate3DsPayload = {
  action: 'Payment' | 'PreAuth' | 'VerifyOnly';
  type:
    | 'Unspecified'
    | 'Internet'
    | 'CallCentre'
    | 'CardPresent'
    | 'ECommerce'
    | 'Ivr'
    | 'MailOrder'
    | 'TelephoneOrder';
  subType: 'Unspecified' | 'Single' | 'Recurring';
  amount: number;
  crn1: string;
  crn2?: string;
  crn3?: string;
  merchantReference?: string;
  currency: string;
  cardholderName: string;
  emailAddress: string;
} & (
  | {
      token: string;
      cardNumber?: never;
      expiryMonth?: never;
      expiryYear?: never;
      cardCvn?: never;
    }
  | {
      token?: never;
      cardNumber: string;
      expiryMonth: string;
      expiryYear: string;
      cardCvn: string;
    }
);

export type Initiate3DsResponse = {
  authkey: string;
  requiresAuthentication: boolean;
  iframeUrl: string | null;
  errorMessage: string | null;
};

export type Complete3DsResponse = {
  success: boolean;
  data?: {
    responseCode: string;
    responseMessage: string;
    transactionNumber: string;
    receiptNumber: string;
    token?: string;
    [k: string]: any;
  };
};

const initiate3ds = (payload: Initiate3DsPayload) =>
  axios.post<Initiate3DsResponse>(
    `${process.env.BFF_USER_API}/bpoint/initiate-3ds`,
    payload,
    { withCredentials: true }
  );

const complete3ds = (authkey: string) =>
  axios.post<Complete3DsResponse>(
    `${process.env.BFF_USER_API}/bpoint/complete-3ds`,
    { authkey },
    { withCredentials: true }
  );

export default {
  initiate3ds,
  complete3ds
};
